import {toast} from 'react-toastify';

import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography'
import RadioGroup from '@material-ui/core/RadioGroup'
import SideStyle from '../style/sideStyle';
import { GreyRadio } from '../style/customUI';
import { loadSTLFile, loadPLYFile } from '../fileIO/fileLoader';

import Param from '../store/param';
import Control from '../store/control';
import ModalForPatientsFile from '../formBk/components/modalForPatientsFile';


const FormSetup = () => {
  const [pullModal, setPullModal] = useState(false);

  const style = SideStyle();
  const param = Param.Get('setup');
  const setParam = Param.Get('setParam');
  const setControl = Control.Get('setControl');


  useEffect(() => {
    setParam(s => {s.activestep = 0})

    // 全てのパラメータをghni最初に全部送って初期化
    var obj = {}
    obj['f00'] = {}

    Object.keys(param).forEach(function (key) {
      obj['f00'][key] = param[key]
    });
  }, []);

  const handleValueScan = (e) => {
    loadPLYFile( e.target.files[0], (mesh) => {
      setControl(s => {s.meshLeg = mesh, s.redrawBox += 1});
      setControl(s => {s.showLeg = true})
    });
    console.log(e.target.files[0].name);

    toast.info('Wait for few seconds to initiate the position.' , {autoClose: 3000});
    setTimeout(() => {
      setCenterButton();
    }, '1000');
  }

  const handleValueInterface = (e) => {
    setParam(s => {s.setup.interface = Number(e.target.value)});
  };

  const handleValueSide = (e) => {
    setParam(s => {s.setup.side = Number(e.target.value)});
  };
  
  const handleValueAkModeling = (e) => {
    setParam(s => {s.setup.akModeling = Number(e.target.value)});
  };

  const setCenterButton = () => {
    setControl(s => {s.toCenterButton = true});
  };


  return (
    <div className={style.outside}>
      <ModalForPatientsFile visible={pullModal} setVisible={setPullModal} onUpload={handleValueScan} />
      <Grid container direction='row' justifyContent='center' alignItems='center' spacing={2}>
        {/*  scan button */}
        <Grid item xs={5}>
          <Button
            component='label'
            className={style.button}
          >
            <input
              id='file'
              accept={['.ply']} 
              type='file'
              name='pathLeg'
              onChange={(e) => handleValueScan(e)}
            />
          </Button>
        </Grid>
        {/* <Grid item xs={5}>
          <Button onClick={() => setPullModal(true)} className={[style.button]} style={{ padding: 4, fontSize: 13 }} component="label">
            Pull from DB
          </Button>
        </Grid> */}
      </Grid>

      {/* side */}
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Typography>Side</Typography>
        </Grid>
        <Grid item xs={4}>
          <RadioGroup aria-label="side" name="side" value={param.side} onChange={handleValueSide} >
            <FormControlLabel value={0} control={<GreyRadio/>} label="Left"/>
            <FormControlLabel value={1} control={<GreyRadio/>} label="Right"/>
          </RadioGroup>
        </Grid>
      </Grid>

      {/* socket type */}
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Typography>Socket type</Typography>
        </Grid>
        <Grid item xs={4}>
          <RadioGroup aria-label="side" name="side" value={0}>
            <FormControlLabel value={0} control={<GreyRadio/>} label="QL(QuadriLateral)"/>
            <FormControlLabel value={1} control={<GreyRadio/>} label="IC(Ischial Ramus Containment)" disabled/>
          </RadioGroup>
        </Grid>
      </Grid>

      {/* modeling type */}
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Typography>Modeling type</Typography>
        </Grid>
        <Grid item xs={4}>
          <RadioGroup aria-label="modeling" name="modeling" value={param.akModeling} onChange={handleValueAkModeling} >
            <FormControlLabel value={0} control={<GreyRadio/>} label="Manual measurement based"/>
            <FormControlLabel disabled value={1} control={<GreyRadio/>} label="Scan based (under trial)"/>
          </RadioGroup>
        </Grid>
      </Grid>
      

      {/* interface */}
      {/* <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Typography>Interface</Typography>
        </Grid>
        <Grid item xs={4}>
          <RadioGroup aria-label="interface" name="interface" value={param.interface} onChange={handleValueInterface} >
            <FormControlLabel value={0} control={<GreyRadio/>} label="Stumpsocks"/>
            <FormControlLabel value={1} control={<GreyRadio/>} label="Softinsert"/>
            <FormControlLabel value={2} control={<GreyRadio/>} label="Liner"/>
          </RadioGroup>
        </Grid>
      </Grid> */}
    </div>
  );
}
export default FormSetup;

